import { call, put, all, takeLatest, debounce } from 'redux-saga/effects'
import { push } from 'connected-react-router'
import { FlowActions, FETCH_FLOWS, FETCH_FLOW_INFO, START_FLOW_VALIDATION, START_SAVING_FLOW } from './actions'
import { Flow, FlowValidationResult } from './types'
import { fetchFlows, fetchFlowInfo, validateFlow, updateFlow, saveFlow } from '../../api/flows'
import { FLOWS } from '../../routes'

const VALIDATION_DEBOUNCE_TIME = 250

export function* loadFlows() {
  try {
    const { data }: { data: Flow[] } = yield call(fetchFlows)
    yield put(FlowActions.fetchFlowSuccess(data))
  } catch (err) {
    // error
  }
}

export function* loadFlow(action: ReturnType<typeof FlowActions.fetchFlowInfo>) {
  try {
    const { data }: { data: Flow } = yield call(fetchFlowInfo, action.payload)
    yield put(FlowActions.fetchFlowInfoSuccess(data))
  } catch (err) {
    // error
  }
}

export function* validateNewFlow(action: ReturnType<typeof FlowActions.startFlowValidation>) {
  const { flow } = action.payload
  const { data }: { data: FlowValidationResult } = yield call(validateFlow, flow)
  yield put(FlowActions.updateFlowValidation(data))
}

export function* savingFlow(action: ReturnType<typeof FlowActions.startSavingFlow>) {
  const { flow } = action.payload
  let data: Flow | null = null
  if (flow.id) {
    const response = yield call(updateFlow, flow.id, flow)
    data = response.data
  } else {
    const response = yield call(saveFlow, flow)
    data = response.data
  }
  if (data) {
    yield put(FlowActions.savingFlowSuccess(data))
    yield put(FlowActions.resetNewFlow())
    yield put(push(FLOWS))
  }
}

export function* rootSaga() {
  yield all([
    takeLatest(FETCH_FLOWS, loadFlows),
    takeLatest(FETCH_FLOW_INFO, loadFlow),
    takeLatest(START_SAVING_FLOW, savingFlow),
    debounce(VALIDATION_DEBOUNCE_TIME, START_FLOW_VALIDATION, validateNewFlow)
  ])
}
